/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";
import {
  calcDuration,
  htmlParse,
  numFormatter,
  remove_tags,
} from "@unisearch/helpers";
import Link from "next/link";
import styles from "./uni_overview_admission.module.scss";

export const UniOverviewAdmission = ({ universityProfileData }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await API.get(
        `public/university-overview/adm-app-overview/${universityProfileData?.universityId}`
      );
      setLoading(false);
      setData(res.data);
    } catch (error) {
      setLoading(false);
      setError("Something went wrong");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const totalCourseCount = data?.admissionRequirement?.reduce(
    (acc, curr) => acc + parseInt(curr?.totalCourse),
    0
  );
  const doc = data?.overviewData?.scholarshipHighlight;
  const minApplicationFeeCheck =
    data?.applicationFee?.minapplicationfee == null ||
    data?.applicationFee?.minapplicationfee == "0.00"
      ? false
      : true;

  const maxApplicationFeeCheck =
    data?.applicationFee?.maxapplicationfee == null ||
    data?.applicationFee?.maxapplicationfee == "0.00"
      ? false
      : true;

  const aplicationFeeCheck = maxApplicationFeeCheck || minApplicationFeeCheck;

  let appFeesResise = "";
  if (minApplicationFeeCheck && maxApplicationFeeCheck) {
    appFeesResise =
      data?.applicationFee?.minapplicationfee?.replace(".00", "") +
      " - " +
      data?.applicationFee?.maxapplicationfee?.replace(".00", "");
  } else if (minApplicationFeeCheck && !maxApplicationFeeCheck) {
    appFeesResise = data?.applicationFee?.minapplicationfee?.replace(".00", "");
  } else if (!minApplicationFeeCheck && maxApplicationFeeCheck) {
    appFeesResise = data?.applicationFee?.maxapplicationfee?.replace(".00", "");
  }

  return (
    <Fragment>
      {totalCourseCount || doc || aplicationFeeCheck ? (
        <section className={styles.section_admission}>
          <div className="container">
            <div className={styles.title_wrapper}>
              <h2>Fees & Admissions Requirements</h2>
              <p className={styles.short_description}>
                Check out the tuition fee ranges, entry requirements, intake
                dates, <br />
                and more for {universityProfileData?.universityName}
              </p>
            </div>

            <Grid
              container
              spacing={6}
              className={styles.content_wrapper}
              justifyContent="center"
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={10}
                className="from_texteditor_wrapper"
              >
                <div className={styles.table_wrapper}>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="2">Admission Requirements</th>
                      </tr>
                    </thead>
                    <tbody>
                      {doc && (
                        <tr>
                          <td>
                            <span>Documents</span>
                          </td>
                          <td>
                            {data?.overviewData.scholarshipHighlight
                              ? htmlParse(
                                  data?.overviewData?.scholarshipHighlight
                                )
                              : ""}
                          </td>
                        </tr>
                      )}

                      {/* application fee */}
                      {aplicationFeeCheck ? (
                        <tr>
                          <td>
                            <span>Application fees</span>
                          </td>

                          <td>
                            {universityProfileData?.countryCurrency}{" "}
                            {appFeesResise}
                          </td>
                        </tr>
                      ) : null}

                      {/* course */}
                      {data && totalCourseCount > 0 && (
                        <tr>
                          <td>
                            <span>Courses</span>
                          </td>
                          <td>
                            <ul className={styles.coursesList}>
                              {data?.admissionRequirement?.map((item, i) => {
                                return (
                                  <Fragment key={i}>
                                    {item?.totalCourse > 0 && (
                                      <li>
                                        <div className={styles.courseLevelName}>
                                          {item?.levelName}
                                        </div>

                                        <div>
                                          <Link
                                            legacyBehavior
                                            href={`/study/${
                                              universityProfileData?.countrySlug
                                            }/university/${
                                              universityProfileData?.universitySlug
                                            }/courses?crl=${item?.levelName?.toLowerCase()}`}
                                          >
                                            <a
                                              className={
                                                styles.course_list_course_link
                                              }
                                            >
                                              ({item?.totalCourse}{" "}
                                              {item?.totalCourse > 1
                                                ? "Courses"
                                                : "Course"}
                                              )
                                            </a>
                                          </Link>
                                        </div>

                                        {item?.minDuration + item?.maxDuration >
                                          0 && (
                                          <div>
                                            Duration:{" "}
                                            {item?.minDuration
                                              ? calcDuration(item?.minDuration)
                                              : ""}{" "}
                                            {item?.maxDuration && "- "}
                                            {item?.maxDuration
                                              ? calcDuration(item?.maxDuration)
                                              : ""}
                                          </div>
                                        )}

                                        {item?.minAmount + item?.maxAmount >
                                          0 && (
                                          <div>
                                            1st Year Tution Fees:{" "}
                                            {item?.minAmount && (
                                              <>
                                                {
                                                  universityProfileData?.countryCurrencySymbol
                                                }
                                                {numFormatter(item.minAmount)}
                                              </>
                                            )}
                                            {item?.maxAmount &&
                                              item.maxAmount != 0 && (
                                                <>
                                                  {` - ${
                                                    universityProfileData?.countryCurrencySymbol
                                                  }${numFormatter(
                                                    item.maxAmount
                                                  )}`}
                                                </>
                                              )}
                                          </div>
                                        )}
                                      </li>
                                    )}
                                  </Fragment>
                                );
                              })}
                            </ul>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Grid>
            </Grid>
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default UniOverviewAdmission;
